import * as React from 'react';
import { DeviceOs } from '../../logic/main/types';

export const DeviceContext = React.createContext<{
  deviceType: 'mobile' | 'tablet' | 'desktop';
  deviceOs: DeviceOs;
}>({ deviceType: 'mobile', deviceOs: null });

interface DeviceProviderPropTypes {
  children?: React.ReactNode;
  deviceType: 'mobile' | 'tablet' | 'desktop';
  deviceOs: DeviceOs;
  visible?: boolean;
}

const DeviceProvider: React.FC<DeviceProviderPropTypes> = ({
  children,
  visible = true,
  deviceType,
  deviceOs,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <DeviceContext.Provider
      value={{ deviceType: deviceType, deviceOs: deviceOs }}
    >
      {children}
    </DeviceContext.Provider>
  );
};

export default React.memo(DeviceProvider);
